import { UserStatus } from '../enums';
import type { UserApi } from '../models';
import { normalizeUserPhone } from './formatUserPhone';

type UserListItem = UserApi & {
  phone?: string | null;
};

export const normalizeListedUser = (user: UserListItem): UserApi => {
  const phoneNumber = normalizeUserPhone(user);
  const status =
    user.status ||
    (user.active === true || user.isActive === true
      ? UserStatus.ACTIVE
      : user.status);

  return {
    ...user,
    phoneNumber,
    status,
  };
};
